import { styled } from "@mui/material/styles";
import { Box } from "@mui/material";

export const ModalHeader = styled(Box)(() => ({
  padding: "24px 24px 0 24px",
  paddingBottom: "20px"
}));

export const ModalContent = styled(Box)(() => ({
  padding: "24px"
}));

export const SystemMileageField = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  border: `1px solid ${theme.palette.divider}`,
  padding: "8px",
  borderRadius: "8px"
}));

export const SystemMileageBadge = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  backgroundColor: theme.palette.primary.light,
  color: theme.palette.primary.main,
  padding: "12px 16px",
  borderRadius: "8px",
  fontSize: "14px",
  fontWeight: 500,
  border: `1px solid ${theme.palette.primary.light}`
}));
